"use strict";
// Using JSDoc comments to allow px value to show through tellisense.
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing40 = exports.spacing36 = exports.spacing32 = exports.spacing28 = exports.spacing24 = exports.spacing20 = exports.spacing16 = exports.spacing14 = exports.spacing12 = exports.spacing11 = exports.spacing10 = exports.spacing09 = exports.spacing08 = exports.spacing07 = exports.spacing06 = exports.spacing05 = exports.spacing04 = exports.spacing035 = exports.spacing03 = exports.spacing025 = exports.spacing02 = exports.spacing015 = exports.spacing01 = exports.spacing005 = void 0;
/**
 * 2px
 */
exports.spacing005 = '0.125rem';
/**
 * 4px
 */
exports.spacing01 = '0.25rem';
/**
 * 6px
 */
exports.spacing015 = '0.375rem';
/**
 * 8px
 */
exports.spacing02 = '0.5rem';
/**
 * 10px
 */
exports.spacing025 = '0.625rem';
/**
 * 12px
 */
exports.spacing03 = '0.75rem';
/**
 * 14px
 */
exports.spacing035 = '0.875rem';
/**
 * 16px
 */
exports.spacing04 = '1rem';
/**
 * 20px
 */
exports.spacing05 = '1.25rem';
/**
 * 24px
 */
exports.spacing06 = '1.5rem';
/**
 * 28px
 */
exports.spacing07 = '1.75rem';
/**
 * 32px
 */
exports.spacing08 = '2rem';
/**
 * 36px
 */
exports.spacing09 = '2.25rem';
/**
 * 40px
 */
exports.spacing10 = '2.5rem';
/**
 * 44px
 */
exports.spacing11 = '2.75rem';
/**
 * 48px
 */
exports.spacing12 = '3rem';
/**
 * 56px
 */
exports.spacing14 = '3.5rem';
/**
 * 64px
 */
exports.spacing16 = '4rem';
/**
 * 80px
 */
exports.spacing20 = '5rem';
/**
 * 96px
 */
exports.spacing24 = '6rem';
/**
 * 112px
 */
exports.spacing28 = '7rem';
/**
 * 128px
 */
exports.spacing32 = '8rem';
/**
 * 144px
 */
exports.spacing36 = '9rem';
/**
 * 160px
 */
exports.spacing40 = '10rem';
//# sourceMappingURL=spacing.js.map